import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useResetEpdRequest = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (uid: string) => Api.orders.resetEpdSigningRequest(uid),
    onSettled: () => client.invalidateQueries(['epd']),
  });
};
